/**
 * Reactivo Web
 */
import legalesReactivo from "../constants/legalesReactivo";

const MAX_FACTURACION = "5.500.000.000,00";

export default {
  googleAnalyticsId: null,
  cantPasos: () => 3,
  ofertaItems: {},
  pasos: {
    landing: {
      component: "views/reactivo/Landing",
      path: "/",
      titulo: "Financiá tu pyme y hacela crecer junto a BBVA",
      subtitulo:
        "Completá los datos y realizá la simulación de límites crediticios para tu empresa en pocos minutos."
    },
    paso1: {
      titulo: "Completá los datos",
      subtitulo:
        "Ingresá la información para que podamos ofrecerte la mejor propuesta de financiación sujeta a tu calificacion crediticia.",
      component: "views/reactivo/Paso1",
      path: "/paso1",
      paso: 1,
      legales: `<h2>Términos y condiciones de tratamiento de datos</h2><h2>Datos personales</h2><p>Los datos personales aquí incluidos tienen el carácter de declaración jurada y son recogidos para ser incorporados y tratados en una base de datos, la cual se encuentra registrada en la Agencia de Acceso a la Información Pública, cuyo destinatario y titular es el BBVA Banco Francés S.A. Cualquier falseamiento, error y/o inexactitud respecto a la información implicará la supresión de estos datos de la base de referencia y no podrán ser utilizados a futuro.</p><p>El usuario presta su consentimiento expreso al BBVA, para que toda la información referente a su persona, sus actividades económicas o las operaciones que haya concertado o que concierte en el futuro (en adelante y en su conjunto "la información") pueda ser transferida y cedida, aun en forma gratuita, dentro de estrictas políticas de confidencialidad y seguridad de los datos, a sus afiliadas, subsidiarias, controlantes, controladas y/o cualquier tercero. La información podrá ser utilizada para: a) La realización de segmentaciones o perfiles del Cliente, con fines comerciales a efectos de adaptar los productos o servicios a necesidades o características específicas, así como con fines de análisis de riesgos para evaluar nuevas operaciones, en ambos supuestos conservando dichas segmentaciones o perfiles en tanto y en cuanto el interviniente mantenga relación contractual con el BBVA, pudiendo oponerse en cualquier momento a dicho tratamiento; b) El envío a través de cualquier medio, por parte del BBVA de otros terceros, de ofertas comerciales, distintos tipos de informaciones o publicidades, personalizadas o no, sobre productos o servicios propios o de terceros; c) Para cualquier otra finalidad no incompatible con las especificadas anteriormente. Cuando así lo disponga, el usuario tendrá el derecho de acceder a la información y solicitar su rectificación o supresión de la base de archivo.</p><p>El BBVA informa al usuario que sus datos personales podrán ser cedidos a las autoridades competentes cuando las leyes o regulaciones de aplicación así lo establezcan.</p><p>En función del Estándar de la Organización para la Cooperación y Desarrollo Económicos (OCDE) para el Intercambio Automático de Información en Asuntos Fiscales y de las disposiciones de la Ley de cumplimiento fiscal de cuentas extranjeras (“Foreign Account Tax Compliance Act” - FATCA) de los Estados Unidos de América, el cliente autoriza al Banco a ceder información a autoridades de terceros países por operatorias desarrolladas en los mercados internacionales tales como Estados Unidos. Lo expuesto, ya sea de forma agregada o individual, según el caso.</p><p>El titular podrá en cualquier momento solicitar el retiro o bloqueo de su nombre de los bancos de datos a los que se refiere el presente artículo. Artículo 27 del Anexo I del Decreto Nº 1558/01: En toda comunicación con fines de publicidad que se realice por correo, teléfono, correo electrónico, Internet u otro medio a distancia a conocer, se deberá indicar, en forma expresa y destacada, la posibilidad del titular del dato de solicitar el retiro o bloqueo, total o parcial, de su nombre de la base de datos. A pedido del interesado, se deberá informar el nombre del responsable o usuario del banco de datos que proveyó la información.</p><p>La Agencia de acceso a la información pública, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.</p><p>La política de envío de e-mails de Banco BBVA Argentina S.A. no incluye la solicitud de ningún tipo de información confidencial (como por ejemplo: claves personales, n° de cuentas, n° de tarjetas de crédito y/o débito, etc.), por lo tanto le sugerimos no enviar dicha información vía e-mail ni tampoco ingresarla en ningún sitio al que usted pueda acceder desde un link disponible dentro de un e-mail excepto que sea bajo el dominio www.bbva.com.ar. No responda este e-mail.</p><h2>Sistemas de Biometría:</h2><p>En caso de que el BBVA defina el uso de dispositivos para la captura, lectura y/o procesamiento de datos –inclusive aquellos de carácter biométricos– en alguno de sus procesos operativos y/o de seguridad aplicables, el usuario autoriza al BBVA a compartir estos datos con terceros exclusivamente para el resguardo de la información capturada, la verificación de la identidad del titular de los datos y/o con los fines que el BBVA determine.</p><h2>Sistemas de información crediticia:</h2><p>Oferta válida por el día de la fecha y hasta el término de 60 días a partir de la recepción del presente, para Nuevos Clientes Personas Jurídicas que facturen hasta el importe de $ ${MAX_FACTURACION} anual que ingresen a la Web Pública del Banco y resulten destinatarias de una Precalificación Crediticia.</p><p>Ante la solicitud de cualquier producto, el BBVA puede solicitar información a las agencias de informes comerciales a fin de evaluar la situación crediticia del usuario.</p><p>El usuario acepta que estará sujeto a la clasificación e inclusión en la "Central de deudores del sistema financiero", de conformidad a la normativa vigente del B.C.R.A., dado que es obligación del BBVA informar, solamente, al Banco Central de la República Argentina todos los datos que éste le requiera o que pudiera requerirle en el futuro, relacionados con sus Clientes. No será responsabilidad del BBVA la utilización de la información del usuario por parte de terceros distintos al B.C.R.A., dado que la misma no es proporcionada por el Banco.</p>`
    },
    oferta: {
      path: "/oferta",
      component: "views/reactivo/Oferta",
      paso: 2,
      nombreSiguiente: "Continuar",
      beneficiosAdicionales: [
        `-Paquete bonificado: 100% de bonificación durante 12 meses.`,
        `-Millas de bienvenida: Sumá hasta 120.000 Millas BBVA.`,
        "-Tasa de préstamos: Contratá tu primer préstamo preferencial al 19,90%.",
        "-Fondos FAL: 0% de comisión de administración por 12 meses, más 100% de reintegro del aporte FAL por la nómina neta que sumes hasta diciembre 2026.",
        "-Terminales de cobro: Comisiones reducidas en adelanto de cupones + 3 días con 30% Off (tope $12.000) y 2 días con 3 cuotas sin interés.",
        "-Comex: Operá en comercio exterior con comisiones preferenciales.",
        "-TC Visa Business: 30% de cashback con tope de $300.000.",
        "-Seguros: Hasta 30% de descuento al presentar la póliza de otra compañía de seguros."
      ],
      tYCDetalle: legalesReactivo
    },
    errorOferta: {
      path: "/errorOferta",
      component: "views/reactivo/ErrorOferta",
      titulo:
        "En este momento no es posible avanzar con esta oferta crediticia",
      beneficios: [
        `Paquete bonificado: 100% de bonificación durante 12 meses.`,
        `Millas de bienvenida: Sumá hasta 120.000 Millas BBVA.`,
        "Tasa de préstamos: Contratá tu primer préstamo preferencial al 19,90%.",
        "Fondos FAL: 0% de comisión de administración por 12 meses, más 100% de reintegro del aporte FAL por la nómina neta que sumes hasta diciembre 2026.",
        "Terminales de cobro: Comisiones reducidas en adelanto de cupones + 3 días con 30% Off (tope $12.000) y 2 días con 3 cuotas sin interés.",
        "Comex: Operá en comercio exterior con comisiones preferenciales.",
        "TC Visa Business: 30% de cashback con tope de $300.000.",
        "Seguros: Hasta 30% de descuento al presentar la póliza de otra compañía de seguros."
      ]
    },
    mensaje: {
      path: "/mensaje/:mje",
      component: "views/Mensaje"
    },
    gracias: {
      component: "views/reactivo/Gracias"
    },
    agropaso1: {
      titulo: "El apoyo financiero que potencia tu producción",
      subtitulo:
        "Vamos a necesitar algunos datos para armar una solución a tu medida",
      component: "views/agro/AgroPaso1",
      path: "/agropaso1",
      paso: 1
    },
    agropaso2: {
      titulo: "El apoyo financiero que potencia tu producción",
      subtitulo:
        "Vamos a necesitar algunos datos para armar una solución a tu medida",
      component: "views/agro/AgroPaso2",
      path: "/agropaso2",
      paso: 2
    },
    agropaso3: {
      titulo: "El apoyo financiero que potencia tu producción",
      subtitulo:
        "Vamos a necesitar algunos datos para armar una solución a tu medida",
      component: "views/agro/AgroPasoMapa",
      path: "/agropaso3",
      paso: 3
    },
    agropaso4: {
      titulo: "El apoyo financiero que potencia tu producción",
      subtitulo:
        "Vamos a necesitar algunos datos para armar una solución a tu medida",
      component: "views/agro/AgroPaso3",
      path: "/agropaso4",
      paso: 4
    },
    agropaso5: {
      subtitulo:
        "¡Solicitalo en nuestras sucursales y seguí haciendo un futuro cada vez más verde e inclusivo!",
      component: "views/agro/AgroPaso4",
      path: "/agropaso5",
      paso: 5
    },
    agroSinOferta: {
      path: "/agroSinOferta",
      component: "views/agro/AgroSinOferta"
    },
    buscadorConvenios: {
      component: "views/agro/BuscadorConvenios",
      path: "/buscador-convenios"
    },
    PaginaMerchant: {
      component: "views/agro/PaginaMerchant",
      path: "/paginaMerchant"
    },
    ConveniosByMerchant: {
      component: "views/agro/ConveniosByMerchant",
      path: "/buscador-convenios/:id/:slug?"
    },
    EsCliente: {
      component: "views/agro/EsCliente",
      path: "/agro/eres-cliente"
    },
    agroError: {
      component: "views/agro/AgroError",
      path: "/agro/error"
    },
    agroErrorBdc: {
      component: "views/agro/BdCAgroError",
      path: "/agro/bdc/error"
    }
  }
};
